import { restApiMP } from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApiMP.get("/api/resource-production-plan", { params });
};

const getAllForCSV = params => {
  return restApiMP.get("/api/resource-production-plan/csv", { params });
};

const resourceProductionPlanService = {
  getAll,
  getAllForCSV
};

export default resourceProductionPlanService;